<template>
  <div class="w-full h-full bg-[#f7f7f7] rounded-md shadow-lg flex flex-col justify-between">
    <div class="rounded-md overflow-x-auto">
      <table class="w-full min-w-[600px] border-collapse">
        <thead class="bg-[#12760A]">
          <tr class="tracking-wider text-left text-xs">
            <th v-if="select" class="text-white p-3 px-4 md:px-8 font-medium">
              <input
                type="checkbox"
                v-model="selectAll"
                @change="toggleSelectAll"
                class="accent-[#12760A]"
              />
            </th>
            <th
              v-for="(head, index) in header"
              :key="index"
              class="text-white p-3 px-3 md:px-3 font-medium text-center">
              {{ head }}
            </th>
          </tr>
        </thead>
        <tbody class="text-sm text-[#646262] max-sm:text-[14px]">
          <tr v-if="!data || data.length === 0">
            <td :colspan="header.length + (select ? 1 : 0)" class="text-center text-[#a3a3a3] p-4 border-b border-[#e7e6e6] ">
              No results found
            </td>
          </tr>
          <tr v-else
            v-for="(row, indexs) in paginatedData"
            :key="indexs"
            :class="[
              'border-[#e7e6e6] border-b',
              indexs % 2 === 0 ? 'bg-white' : 'bg-[#f8f8f8] '
            ]">
            
            <td v-if="select" class="px-3 md:px-3 py-1">
              <input
                type="checkbox"
                v-model="selectedRows"
                :value="row.ref_no"
                class="accent-[#12760A]"
              />
            </td>

            <td
              v-for="(col, index) in column"
              :key="index"
              class="px-3 md:px-3 py-2 align-top text-left">
              
              <span v-if="col === 'status'" class="font-semibold text-center text-[10px] max-sm:font-medium flex max-w-[150px] justify-center items-center">
                <div v-if="row[col] === 'APPROVED'" class="bg-[#016B00] text-white  rounded-sm py-[1px] w-full">
                  {{ row[col] }}
                </div>
                <div v-else-if="row[col] === 'DISAPPROVED' || row[col] === 'CANCELLED'" class="bg-[#691c1c] text-white  rounded-sm py-[1px] w-full">
                  {{ row[col] }}
                </div>
                <div v-else class="bg-[#dbdbdb] text-[#837d7d]  rounded-sm py-[1px] w-full whitespace-nowrap">
                  {{ row[col] }}
                </div>
              </span>
              <span v-else-if="col === 'pay_month'">
                <div>
                  <p class="text-md">PAYSLIP FOR THE MONTH OF {{ monthToWords(row[col]) }} {{ row.pay_year }}</p>
                </div> 
              </span>
              <span v-else-if="col === 'action'">
                <div 
                  v-if="viewBtn" 
                  @click="$emit('clickView', row)"
                  class="text-xs cursor-pointer hover:text-[#dfdfdf] underline text-green-700 font-medium text-center">
                  View
                </div>
                <div 
                  v-else-if="encode" 
                  @click="$emit('encodeRequest', row.ref_no)"
                  class="text-xs cursor-pointer hover:text-[#dfdfdf] underline text-green-700 font-medium text-center">
                  Encode
                </div>
                <div 
                  v-else-if="check" 
                  @click="$emit('encodeRequest', row.ref_no)"
                  class="text-xs cursor-pointer hover:text-[#dfdfdf] underline text-green-700 font-medium text-center">
                  Check
                </div>
              </span>
              <span v-else-if="col === 'reason' || col === 'leave_date'">
                <div class="w-[230px]">
                  <p class="text-md break-words">
                    {{
                      row[`showFull_${col}`]
                        ? row[col]
                        : (row[col] || '').slice(0, 30)
                    }}

                    <span
                      v-if="!row[`showFull_${col}`] && (row[col] || '').length > 30"
                    >
                      ...
                    </span>

                    <button
                      v-if="(row[col] || '').length > 30"
                      @click="row[`showFull_${col}`] = !row[`showFull_${col}`]"
                      class="text-xs text-green-600 hover:underline inline-block font-medium"
                    >
                      {{ row[`showFull_${col}`] ? 'Show Less' : 'View All' }}
                    </button>
                  </p>
                </div>
              </span>
              <span v-else-if="col === 'employee_key'">
                <div>
                    {{ getEmployeename(row[col]) }}
                </div>
               </span>
              <span v-else-if="col === 'submit_date' || col === 'duration' ">
                <div class="text-center">
                    {{ row[col] }}
                </div>
               </span>
              <span v-else>{{ row[col] }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-between items-center space-x-2 px-4 border-t py-4 bg-white rounded-b-md">
      <div class="text-xs text-[#837d7d]">
        <p>Total Records: {{ data?.length || 0 }}</p>
      </div>
      
      <div class="flex gap-1 items-center">
        <button
          @click="prevPage"
          :disabled="currentPage === 1"
          class="px-3 py-1 bg-[#12760A] text-white rounded-sm disabled:opacity-50 disabled:cursor-not-allowed text-sm">
          &lt; Prev
        </button>

        <button
          v-for="(page, idx) in displayedPages"
          :key="idx"
          @click="goToPage(page)"
          :disabled="page === '...'"
          :class="{
            'bg-[#12760A] text-white border border-[#12760A]': currentPage === page,
            'bg-white text-[#12760A] border border-[#12760A]': currentPage !== page && page !== '...',
            'border-none bg-transparent text-gray-400 cursor-default pointer-events-none': page === '...'
          }"
          class="px-3 py-1 rounded-sm hover:bg-[#0f5008] hover:text-white transition text-sm font-medium">
          {{ page }}
        </button>

        <button
          @click="nextPage"
          :disabled="currentPage === totalPages"
          class="px-3 py-1 bg-[#12760A] text-white rounded-sm disabled:opacity-50 disabled:cursor-not-allowed text-sm">
          Next &gt;
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaginatedTable',
  props: {
    header: { type: Array, default: () => [] },
    column: { type: Array, default: () => [] },
    data: { type: Array, default: () => [] },
    select: { type: Boolean, default: false },
    viewBtn: { type: Boolean, default: false },
    encode: { type: Boolean, default: false },
    check: { type: Boolean, default: false },
    pageSize: { type: Number, default: 20 },
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      selectAll: false,
      // Refactored into a direct key-value map for faster rendering lookups
      monthsMap: {
        '01': 'JANUARY', '02': 'FEBRUARY', '03': 'MARCH', '04': 'APRIL',
        '05': 'MAY', '06': 'JUNE', '07': 'JULY', '08': 'AUGUST',
        '09': 'SEPTEMBER', '10': 'OCTOBER', '11': 'NOVEMBER', '12': 'DECEMBER'
      }
    };
  },
  computed: {
    // Converts page logic to calculations that scale dynamically without performance lag
    totalPages() {
      return Math.ceil((this.data?.length || 0) / this.pageSize) || 1;
    },
    
    // Returns only the current slice of data matching your pageSize configuration
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return (this.data || []).slice(start, start + this.pageSize);
    },

    // Generates a dynamic array loop window like [1, '...', 12, 13, 14, '...', 225]
    displayedPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxVisible = 5; 
      
      if (total <= maxVisible) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      let start = Math.max(current - Math.floor(maxVisible / 2), 1);
      let end = start + maxVisible - 1;

      if (end > total) {
        end = total;
        start = Math.max(end - maxVisible + 1, 1);
      }

      const pages = [];
      
      if (start > 1) {
        pages.push(1);
        if (start > 2) pages.push('...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < total) {
        if (end < total - 1) pages.push('...');
        pages.push(total);
      }

      return pages;
    }
  },
  methods: {
    getEmployeename(emp_key){
      return this.$store.state.list_employee.find(e=> e.key == emp_key)?.value ?? ''
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
      this.resetSelectAll();
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
      this.resetSelectAll();
    },
    goToPage(page) {
      if (page === '...') return;
      this.currentPage = page;
      this.resetSelectAll();
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedRows = this.paginatedData.map(row => row.ref_no);
      } else {
        this.selectedRows = [];
      }  
    },
    resetSelectAll() {
      this.selectAll = false;
      this.selectedRows = [];
    },
    monthToWords(codes) {
      const code = String(codes).padStart(2, '0');
      return this.monthsMap[code] || null;
    }
  },
  watch: {
    data: {
    
      handler() {
        this.currentPage = 1;
        this.resetSelectAll();
      }
    }
  }
});
</script>